import * as Mutations from '../../mutations';

export default {
  setClientLogo({ commit }, clientLogo) {
    commit(Mutations.SET_CLIENT_LOGO, clientLogo);
  },
};
